module.exports = __webpack_public_path__ + "img/offers9.f113b2e2.jpg";